import Job from '../models/Job'
import ActualReason from '../models/ActualReason'
import EventHistory from '../models/EventHistory'
import JobCause from '../models/JobCause'
import JobResolution from '../models/JobResolution'
import Site from '../models/Site'
import SystemTest from '../models/SystemTest'
import TimeZone from '../models/TimeZone'
import Zone from '../models/Zone'

export const store = {
  debug: true,
  state: {
    loaded: false,
    currentJob: new Job(),
    isInstallJob: false,
    site: new Site(),
    systemTest: new SystemTest(),
    zones: [],
    signalTestEventHistory: [],
    ninetyDayEventHistory: [],
    timeZoneInfo: new TimeZone(),
    jobCauses: [],
    actualReasons: [],
    jobResolutions: [],
    errorAlert: {
      msg: '',
      isDismissed: true,
    },
    fifteenMinutesAcknowledged: false,
  },
  updateSystemTest(systemTest, timeZoneInfo) {
    this.state.systemTest.mapFromApi(systemTest, timeZoneInfo)
  },
  putSystemOffTest() {
    this.state.systemTest = new SystemTest()
  },
  updateTechStatusToEnroute() {
    this.state.currentJob.jobEmployeeStatus = 'E'
  },
  updateTechStatusToOnSite() {
    this.state.currentJob.jobEmployeeStatus = 'O'
  },
  markJobComplete() {
    this.state.currentJob.jobEmployeeStatus = 'C'
  },
  updateTimeZoneInfo(timeZoneInfo) {
    this.state.timeZoneInfo.mapFromApi(timeZoneInfo)
  },
  updateJobFromApi(jobData) {
    // Google Analytics/Tag Manager
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      { job: this.state.currentJob },
      { jobType: this.isInstallJob ? 'install' : 'service' },
      { site: this.state.site }
    )
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

    this.state.currentJob.mapFromApi(jobData)
    this.state.site.mapFromApi(jobData)

    if (
      jobData.system_test &&
      this.state.timeZoneInfo.timeZoneNumber !== null
    ) {
      this.updateSystemTest(jobData.system_test, this.state.timeZoneInfo)
    }

    this.state.loaded = true
  },
  updateSiteFromApi(siteData) {
    this.state.site.mapFromApi(siteData)
  },
  presentErrorAlert(alertMsg) {
    this.state.errorAlert.isDismissed = false
    this.state.errorAlert.msg = alertMsg
  },
  dismissErrorAlert() {
    this.state.errorAlert.isDismissed = true
    this.state.errorAlert.msg = ''
  },
  setFifteenMinutesAcknowledged() {
    this.state.fifteenMinutesAcknowledged = true
  },
  resetFifteenMinutesAcknowledged() {
    this.state.fifteenMinutesAcknowledged = false
  },
  updateZones(zones) {
    this.state.zones = []
    zones.forEach((zone) => {
      const zoneForState = new Zone()
      zoneForState.mapFromApi(zone)
      this.state.zones.push(zoneForState)
    })
  },
  updateSignalTestEventHistory(eventHistory, timeZoneInfo) {
    this.state.signalTestEventHistory = []
    if (eventHistory.length > 0) {
      this.updateZoneSignalReceivedFlag(eventHistory)
      eventHistory.forEach((responseEventHistory) => {
        const eh = new EventHistory()
        eh.mapFromApi(responseEventHistory, timeZoneInfo)
        this.state.signalTestEventHistory.push(eh)
      })
    }
  },
  updateZoneSignalReceivedFlag(eventHistory) {
    this.state.zones.forEach((zone) => {
      zone.signalReceived =
        eventHistory.findIndex(
          (eh) => eh.ZoneId === zone.zoneId && eh.EventId === zone.eventId
        ) !== -1
    })
  },
  updateNinetyDayEventHistory(history, timeZoneInfo) {
    this.state.ninetyDayEventHistory = []
    if (history.length > 0) {
      history.forEach((responseEvent) => {
        const event = new EventHistory()
        event.mapFromApi(responseEvent, timeZoneInfo)
        this.state.ninetyDayEventHistory.push(event)
      })
    }
  },
  updateJobCodes(jobCodes) {
    this.updateJobCauses(jobCodes.JobCauses)
    this.updateActualReasons(jobCodes.ActualReasons)
    this.updateJobResolutions(jobCodes.JobResolutions)
  },
  updateJobCauses(jobCauses) {
    this.state.currentJobCauses = []
    jobCauses.forEach((responseJobCause) => {
      const cause = new JobCause()
      cause.mapFromApi(responseJobCause)
      this.state.currentJobCauses.push(cause)
    })
  },
  updateActualReasons(actualReasons) {
    this.state.actualReasons = []
    actualReasons.forEach((reasonData) => {
      const reason = new ActualReason()
      reason.mapFromApi(reasonData)
      this.state.actualReasons.push(reason)
    })
  },
  updateJobResolutions(jobResolutions) {
    this.state.currentJobResolutions = []
    jobResolutions.forEach((jobResolutionData) => {
      const resolution = new JobResolution()
      resolution.mapFromApi(jobResolutionData)
      this.state.currentJobResolutions.push(resolution)
    })
  },
  setJobTypeAsInstall() {
    this.isInstallJob = true
  },
  resetJobType() {
    this.isInstallJob = false
  },
  unloadState() {
    this.state.loaded = false
  },
}
